import { useEffect } from 'react';
import { PaginationState } from '../questionnaires/paginationSlice';
import { QuestionnairePaginationCombinedGeneralProps } from '../_components/questionnaire-paginator-types';

export function useInitialiseExtraHooks(
  paginationState: PaginationState,
  props: QuestionnairePaginationCombinedGeneralProps<any>
) {
  useEffect(
    () => {
      props.onStateChange(paginationState);
    },
    // eslint-disable-next-line
    [paginationState.currentPage, paginationState.currentSection]
  );

  useEffect(
    () => {
      props.onPageChange?.(paginationState.currentPage);
    },
    // eslint-disable-next-line
    [paginationState.currentPage]
  );

  useEffect(
    () => {
      props.onSectionChange?.(paginationState.currentSection);
    },
    // eslint-disable-next-line
    [paginationState.currentSection]
  );
}
export function getCurrentProgress(paginationState: PaginationState) {
  const lengthInCurrentSection =
    paginationState.formattedSections[paginationState.currentSection]
      ?.pageLength ?? 1;
  return (
    paginationState.currentSection +
    (paginationState.currentPage * 1) / lengthInCurrentSection
  );
}
